<!-- ── Bar 1: Games (identidad visual) ── -->
<section class="blog-toolbar-bar1">
  <div class="blog-page__inner blog-toolbar-bar1__header">
    <app-breadcrumb [items]="breadcrumbs()" />
    <h1 class="blog-toolbar-bar1__title">{{ copy.listTitle }}</h1>
  </div>
  <div class="blog-page__inner blog-toolbar-bar1__pills">
    <button
      type="button"
      class="blog-toolbar__pill"
      [class.blog-toolbar__pill--active-all]="activeGame() === null"
      (click)="onGameChange(null)"
    >{{ copy.allGames }}</button>

    @for (game of sortedGames(); track game.id) {
      <button
        type="button"
        class="blog-toolbar__pill"
        [class.blog-toolbar__pill--active]="activeGame() === game.slug"
        [style.--pill-accent]="game.accentColor"
        (click)="onGameChange(game.slug)"
      >{{ game.name }}</button>
    }
  </div>
</section>

<!-- ── Bar 2: Herramientas de filtrado ── -->
<section class="blog-toolbar-bar2">
  <div class="blog-page__inner">
    <app-blog-filter-bar
      [categories]="allCategories()"
      [tags]="allTags()"
      [activeCategory]="activeCategory()"
      [activeTag]="activeTag()"
      [searchValue]="searchQuery()"
      [resultsCount]="resultsCount()"
      (categoryChange)="onCategoryChange($event)"
      (tagChange)="onTagChange($event)"
      (searchChange)="onSearchChange($event)"
    />
  </div>
</section>

<!-- ── Chips de filtros activos ── -->
@if (activeFilterChips().length > 0) {
  <section class="blog-toolbar-chips">
    <div class="blog-page__inner blog-toolbar-chips__row">
      @for (chip of activeFilterChips(); track chip.key) {
        <button
          type="button"
          class="blog-toolbar-chip"
          (click)="removeFilter(chip.key)"
        >
          {{ chip.label }}
          <span class="blog-toolbar-chip__x" aria-hidden="true">&times;</span>
        </button>
      }
      @if (activeFilterChips().length >= 2) {
        <button
          type="button"
          class="blog-toolbar-chips__clear"
          (click)="clearFilters()"
        >{{ copy.clearFilters }}</button>
      }
    </div>
  </section>
}

<!-- ── Featured ── -->
@if (featuredPost(); as featured) {
  <section class="blog-page__featured">
    <div class="blog-page__inner">
      <app-blog-featured-card [post]="featured" />
    </div>
  </section>
}

<!-- ── Grid ── -->
<section class="blog-page__grid-section">
  <div class="blog-page__inner">
    @if (loadError()) {
      <!-- B123: la API no respondió. Misma mascota que los errores de pago
           (checkout-payment-page); width/height intrínsecos, sin CLS. -->
      <div class="blog-page__empty blog-page__error" role="alert">
        <img
          src="/images/logo/charging_error.png"
          [alt]="copy.errorMascotAlt"
          class="blog-page__empty-mascot"
          width="640"
          height="626"
          loading="lazy"
        />
        <p class="blog-page__empty-title">{{ copy.listLoadError }}</p>
        <app-button variant="secondary" (click)="retry()">
          {{ copy.retry }}
        </app-button>
      </div>
    } @else if (paginatedPosts().length > 0) {
      <div class="blog-page__grid">
        @for (post of paginatedPosts(); track post.id) {
          <app-blog-card [post]="post" />
        }
      </div>

      @if (totalPages() > 1) {
        <div class="blog-page__pagination">
          <app-pagination
            [currentPage]="currentPage()"
            [totalPages]="totalPages()"
            (pageChange)="onPageChange($event)"
          />
        </div>
      }
    } @else {
      <!-- Estado vacío (width/height intrínsecos, sin CLS) -->
      <div class="blog-page__empty">
        <img
          src="/images/logo/community_lupa.png"
          [alt]="copy.emptyMascotAlt"
          class="blog-page__empty-mascot"
          width="460"
          height="446"
          loading="lazy"
        />
        <p class="blog-page__empty-title">{{ copy.emptyTitle }}</p>
        <p class="blog-page__empty-text">{{ copy.emptyText }}</p>
        <app-button variant="secondary" (click)="clearFilters()">
          {{ copy.emptyCta }}
        </app-button>
      </div>
    }
  </div>
</section>

<!-- ── Newsletter ── -->
<section class="blog-page__newsletter">
  <div class="blog-page__inner blog-page__newsletter-content">
    <app-newsletter-form
      variant="hero"
      inputId="blog-newsletter-email"
      [placeholder]="copy.newsletterPlaceholder"
      [ctaLabel]="copy.newsletterCta"
      [heading]="copy.newsletterHeading"
      [description]="copy.newsletterDescription"
    />
  </div>
</section>
